import React from 'react';
import { Section, SectionTitle } from '../../../components/TwoColumnLayout';
import styled from 'styled-components';
import { StyledInput } from '../../../components/StyledInput';
import { CustomerValues } from '../CustomerValues';

interface Props {
	accountType: string;
	customerDeliveryData: any;
	customerValues: CustomerValues;
	handleCustomerDataChange: (e: React.ChangeEvent<HTMLInputElement>) => void
}

const Wrapper = styled.div`
  width: 18em;
  margin: auto;
`;

const Container = styled.div`

  padding-top: 1rem;
    input {
    width: 250px;
  }

  input[type="text"] {
    min-width: 450px;
  }

  .info{
    width: 200px;
    font-size: 1rem;
    padding-left: 1rem;
    // border: 1px solid red;
  }

  .grayInfo{
    font-size: 1rem;
    color: darkgray;
  }
`;

const InputContainer = styled.div`
  width: 100%;
  height: 2.5em;
  margin-bottom: 2em;
`;

const Header = styled.div`
  font-size: 1.6em;
  text-align: center;
  margin-bottom: 1em;
`;

export const DeliveryInfo: React.FC<Props> = (props: Props) => {
	return (
		<div>
			{props.accountType === 'consumer' && (
				<Wrapper>
					<Header>Toimitus-/kotiosoite</Header>
					<InputContainer>
						<StyledInput
							title={'Katuosoite'}
							name={'streetAddress'}
							backgroundColor={'white'}
							value={props.customerValues.streetAddress.value !== null ? props.customerValues.streetAddress.value : props.customerDeliveryData.streetAddress}
							onChange={props.handleCustomerDataChange}
						/>
					</InputContainer>
					<InputContainer>
						<StyledInput
							title={'Postinumero'}
							name={'postalCode'}
							backgroundColor={'white'}
							value={props.customerValues.postalCode.value !== null ? props.customerValues.postalCode.value : props.customerDeliveryData.postalCode}
							onChange={props.handleCustomerDataChange}
						/>
					</InputContainer>
					<InputContainer>
						<StyledInput
							title={'Postitoimipaikka'}
							name={'city'}
							backgroundColor={'white'}
							value={props.customerValues.city.value !== null ? props.customerValues.city.value : props.customerDeliveryData.city}
							onChange={props.handleCustomerDataChange}
						/>
					</InputContainer>
				</Wrapper>
			)}
			{props.accountType !== 'consumer' && (
				<div>
					<SectionTitle>Toimitusosoite</SectionTitle>
					<Section>
						<Container>
							<div className="info">
								<input
									value={props.customerDeliveryData.streetAddress ? props.customerDeliveryData.streetAddress : 'Tietoa ei saatavilla'}
									type="text"
									readOnly
								/>
								<input
									value={`${props.customerDeliveryData.city ? props.customerDeliveryData.city : 'Tietoa ei saatavilla'} ${props.customerDeliveryData.postalCode ? props.customerDeliveryData.postalCode : 'Tietoa ei saatavilla'}`}
									type="text"
									readOnly
								/>
							</div>
						</Container>
					</Section>
				</div>
			)}
		</div>
	);
};
